import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useRouter } from 'next/router';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { ArrowRight } from 'phosphor-react';

import * as types from '../../../../../actions/actionTypes';
import {
  Clementine,
  Carnation,
  SunshineCover,
} from '../../../../utility/Icons';
import { buttonStyles } from '../../../../../styles/base';
import styles from '../../../../../styles/sass/pages/SignUpNew.module.scss';

export interface CoverProps {
  classes: any;
  goToNextPage: Function;
  handleBrowserNavigation: Function;
}

export const Cover: React.FC<CoverProps> = ({
  classes,
  goToNextPage,
  handleBrowserNavigation,
}) => {
  const router = useRouter();

  //Browser Navigation handle
  useEffect(() => {
    handleBrowserNavigation('cover');
  }, []);

  const goToNext = () => {
    goToNextPage();
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          question: 'property',
        },
      },
      undefined,
      {
        shallow: false,
      },
    );
  };

  return (
    <div className={styles.stageContainer}>
      <div className={styles.stageImage}>
        <div className={styles.infoBasicsImage} />
        <div className={styles.coverStickerBase}>
          <span className={styles.clementineSticker}>
            <span className={styles.stickerText}>spacious</span>
            <Clementine />
          </span>
          <span className={styles.carnationSticker}>
            <span className={styles.stickerText}>
              great <br /> kitchen
            </span>
            <Carnation />
          </span>
          <span className={styles.sunshineSticker}>
            <span className={styles.stickerText}>
              lots of <br /> natural light
            </span>
            <SunshineCover />
          </span>
        </div>
      </div>
      <div className={[styles.stageInfo, styles.SignupInfoStage].join(' ')}>
        <div className={styles.stageNavigation}>
          <div className={styles.navigationActive}>
            <span className={[styles.navigation, styles.active].join(' ')}>
              1. The Basics
            </span>
            <span className={styles.activeBar} />
          </div>
          <span className={styles.navigation}>2. Ideal Neighborhood</span>
          <span className={styles.navigation}>3. Your Lifestyle</span>
        </div>
        <div className={styles.stageTextContainer}>
          <span style={{ color: '#2C5853' }} className={styles.stageTitle}>
            01.
          </span>
          <span className={styles.stageTitle}>The Basics</span>
          <span
            className={[styles.stageSubtitle, styles.signupInfoSubtitle].join(
              ' ',
            )}
          >
            Let's move on to learning about what <br className="no-desktop" />{' '}
            you're <br className="no-tablet no-mobile" /> looking for in a
            neighborhood
          </span>
        </div>
        <div
          className={[styles.buttonContainer, styles.getStartedButton].join(
            ' ',
          )}
        >
          <Button
            variant="contained"
            color="secondary"
            size="large"
            className={classes.buttonSignupGreenSmall}
            onClick={() => goToNext()}
          >
            <span className={styles.buttonText}>Get started</span>
            <ArrowRight size={24} color="#FFFFFF" weight="bold" />
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps, null)(withStyles(buttonStyles)(Cover));
